import React, { createContext, useContext, useEffect, useState } from 'react'
import ProgramItem from './ProgramItem'

interface IState {
  program: {
    id: number | string
    name: string | null
  }
  season?: number | null
  setSeason: React.Dispatch<React.SetStateAction<number | null>>
  seasonNumber?: number | null
  setSeasonNumber: React.Dispatch<React.SetStateAction<number | null>>
  episode?: number | null
  setEpisode: React.Dispatch<React.SetStateAction<number | null>>
  episodeNumber?: number | null
  setEpisodeNumber: React.Dispatch<React.SetStateAction<number | null>>
}

const initState: IState = {
  program: {
    id: 0,
    name: '',
  },
  season: 0,
  setSeason: function (value: React.SetStateAction<number | null>): void {
    throw new Error('Function not implemented.' + value)
  },
  seasonNumber: 1,
  setSeasonNumber: function (value: React.SetStateAction<number | null>): void {
    throw new Error('Function not implemented.' + value)
  },
  episode: null,
  setEpisode: function (value: React.SetStateAction<number | null>): void {
    throw new Error('Function not implemented.' + value)
  },
  episodeNumber: 0,
  setEpisodeNumber: function (
    value: React.SetStateAction<number | null>
  ): void {
    throw new Error('Function not implemented.' + value)
  },
}
const ProgramContext = createContext(initState)
export const ProgramProvider = ({
  seriesId,
  seriesName,
  seasonNum,
  foundEpisode,
}: {
  seriesId: number
  seriesName: string | null
  seasonNum: number | null
  foundEpisode: number | null
}) => {
  const [series, setSeries] = useState<{ id: number; name: string | null }>({
    id: seriesId,
    name: seriesName,
  })
  const [season, setSeason] = useState<number | null>(seasonNum)
  const [seasonNumber, setSeasonNumber] = useState<number | null>(seasonNum)
  const [episode, setEpisode] = useState<number | null>(foundEpisode)
  const [episodeNumber, setEpisodeNumber] = useState<number | null>(null)

  useEffect(() => {
    setSeason(seasonNum)
    setSeasonNumber(seasonNum)
  }, [seasonNum])

  useEffect(() => {
    setEpisode(foundEpisode)
  }, [foundEpisode])

  useEffect(() => {
    setSeries({ id: seriesId, name: seriesName })
  }, [seriesId, seriesName])

  return (
    <ProgramContext.Provider
      value={{
        program: series,
        season: season,
        setSeason: setSeason,
        seasonNumber: seasonNumber,
        setSeasonNumber: setSeasonNumber,
        episode: episode,
        setEpisode: setEpisode,
        episodeNumber: episodeNumber,
        setEpisodeNumber: setEpisodeNumber,
      }}
    >
      <ProgramItem key={'ProgramItem'} />
    </ProgramContext.Provider>
  )
}
export const useProgramContext = () => {
  return useContext(ProgramContext)
}
